import { render, staticRenderFns } from "./SkeletonSearchbarTransationDetailComponent.vue?vue&type=template&id=7da4ad36&scoped=true&"
import script from "./SkeletonSearchbarTransationDetailComponent.vue?vue&type=script&lang=js&"
export * from "./SkeletonSearchbarTransationDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonSearchbarTransationDetailComponent.vue?vue&type=style&index=0&id=7da4ad36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da4ad36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
